import util from 'util'
import Promise from 'bluebird'
import {vals, formatPortfolioImport} from '../../../util'

const COMPANY_HEADERS = ['sector', 'geography', 'stage', 'status', 'name']
const stringify = JSON.stringify

function checkDefaults(data) {
    let dkeys = _.keys(vals.PORTFOLIO_DEFAULTS)
    return _.map(data, gram => {
        // default values for specific columns
        return _.forIn(gram, (v,k,o) => {
            let invalid = (_.isNil(v) || (typeof v === 'string' && _.isEmpty(v)) || (typeof v === 'number' && _.isNaN(v)))
            if (_.indexOf(dkeys, k) >= 0 && invalid) {
                delete o[k]
                o[k] = vals.PORTFOLIO_DEFAULTS[k]
            }
            return o[k]
        })
    })
}

let state = {
    server_data     : [], // data structure
    has_data        : false,
    _interval       : -1,
    _write_timer    : 0,
    _read_timer     : 0,
    _processing_cycle   : false // necessary to make sure we aren't doing multiple reads/writes at the same time (single thread for now)
}

const getters = {
    portfolioData    : state => {
        // concat our server_data and local_cache -- both make up our data
        let retval = _.map(state.server_data, data => {
            // return all properties that don't start with '_'
            return _.omitBy(_.assign(data, {}), function(v,k) {return _.startsWith(k, '_')})
        })
        return retval
    },
    hasData : state => {
        return state.has_data || state.server_data.length > 0
    },
    isDirty       : function(state) {
        return false
    },
    portfolioValue  : function(state,getters) {
        // return value of portfolio
        return _.reduce(getters['portfolioData'], (memo,data) => {
            return memo + data.value
        },0)
    },
    portfolioCost   : function(state,getters) {
        return _.reduce(getters['portfolioData'], (memo,data) => {
            return memo + data.cost
        }, 0)
    },
    portfolioGain   : function(state,getters) {
        return getters['portfolioValue'] - getters['portfolioCost']
    },
    portfolioCount  : function(state) {
        return state.server_data.length
    }
}

const mutations = {
    initialize (state) {
        // revert the portfolio back to '0'
        state.server_data = []
        state.has_data = false
        if (state._interval > 0) clearInterval(state._interval) // clear out our current interval
        state._interval = -1
        state._write_timer = 0
        state._read_timer = 0
        state._processing_cycle = false
    },
    markData (state, payload) {
        state.has_data = payload.hasData || state.server_data.length > 0
    },
    overwrite (state, payload) {
        // stomp on our current data, this will wipe out local changes
        let formatData = checkDefaults(payload) // make sure we have correct default values
        state.server_data = formatData
        // stomp local changes
        state.local_cache = []
    },
    clean (state, payload) {
        // payload is data written to the server
        // remove any data older than _sent from the local cache
        // state.local_cache = _.without(_.map(state.local_cache, cached => {
        //     let item = _.find(payload, function(p) {return p._id == cached._id})
        //     if (!item || item._sent < cached._dirty) return cached // return only if dont have it in the payload or it is newer
        // }), undefined, null)
    },
    merge (state, payload) {
        // merge what was returned from the server with what we have in server
        state.server_data = _.without(_.map(state.server_data, data => {
            if (!data) return data
            let index = _.findIndex(payload, function(p) {return p._id == data._id})
            if (index >= 0) {
                let item = _.first(_.pullAt(payload, index))
                if (_.lte(item.__v, data.__v)) return data
                return _.omit(_.merge(data, item), ['_sent', '_dirty'])
            }
            return data
        }),null,undefined)
        // add remaining updates
        state.server_data = _.concat(state.server_data, payload)
    },
    update (state, payload) {
        // add payload data to our local cache
        if (!_.isArray(payload)) payload = [payload]
        // merge our payload with the data
        state.server_data = _.map(state.server_data, cache => {
            let index = _.findIndex(payload, function(i) {return i.name == cache.name})
            if (index >= 0) {
                let item = _.first(_.pullAt(payload, index))
                return _.merge(cache, item)
            }
            return cache
        })
    }
}

const actions = {
    start ({}) {},
    stop ({}) {},
    cycle ({}) {},
    forceRead ({}) {},
    forceWrite ({}) {},
    update ({commit}, payload) {
        commit('update', payload)
        return Promise.resolve({})
    },
    _apiFetchPortfolio ({commit,state}) {
        // ignore in fake
    },
    apiFetchPortfolio ({state}) {
        return new Promise((resolve, reject) => {
            resolve({})
        })
    },
    apiPostPortfolio ({commit}, payload) {
        return new Promise((resolve, reject) => {
            let fdata = _.map(payload, formatPortfolioImport)
            fdata = _.map(fdata, item => {
              item.company_name = item.name
              return item
            })
            commit('overwrite', fdata)
            //need to send data to company store
            let companies = _.map(payload, item => {
              return _.pickBy(item, function (v,k) {return _.indexOf(COMPANY_HEADERS, k) >= 0})
            })
            commit('company/merge', {companies}, {root: true})
            resolve({data: {success: 1, fail: 1, errors: []}})
        })
    },
    apiPatchPortfolio ({commit,state}) { //unused in fake api
    }
}

export default {
    namespaced : true,
    state,
    getters,
    mutations,
    actions
}